import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

const tickerItems = [
  "综艺棚录现场临时改规则，导播连切三路画面",
  "影视剧组为一场雨戏连等三天，只为雨丝密度一致",
  "剪辑台最新一期：三分钟戏份被删，只因节奏泄了气",
  "两百人群戏如何一秒安静，副导演的分组办法公开",
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  const navLinkClass = (path: string) =>
    `relative px-3 py-2 text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
      isActive(path)
        ? "text-accent-700"
        : "text-foreground-800 hover:text-accent-700"
    }`;

  return (
    <header className="sticky top-0 z-50">
      {/* 快讯滚动条 */}
      <div className="bg-foreground-950 text-background-100 overflow-hidden">
        <div className="max-w-portal mx-auto flex items-center h-9">
          <span className="flex items-center gap-1.5 shrink-0 px-4 h-full bg-accent-500 text-background-50 text-xs font-bold">
            <i className="ri-flashlight-fill w-3.5 h-3.5 flex items-center justify-center" />
            现场快讯
          </span>
          <div className="relative flex-1 overflow-hidden h-full flex items-center">
            <div className="ticker-track">
              {[0, 1].map((dup) => (
                <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
                  {tickerItems.map((item, idx) => (
                    <span
                      key={`${dup}-${idx}`}
                      className="text-xs text-background-200 px-6 inline-flex items-center gap-2 whitespace-nowrap"
                    >
                      <span className="w-1 h-1 rounded-full bg-primary-500" aria-hidden="true" />
                      {item}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`bg-background-50/95 backdrop-blur border-b-2 border-foreground-950 transition-shadow ${
          scrolled ? "shadow-[0_2px_0_0_rgba(0,0,0,0.04)]" : ""
        }`}
      >
        <div className="max-w-portal mx-auto px-4 md:px-6">
          <div className="flex items-center h-16 gap-4">
            <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded bg-accent-500 text-background-50 font-heading font-black text-lg">
                黑
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black text-foreground-950 tracking-tight">
                  黑料八卦
                </span>
                <span className="text-[10px] text-foreground-500 tracking-[0.22em] mt-0.5">
                  镜头之外
                </span>
              </span>
            </Link>

            <nav className="hidden lg:flex items-center gap-0.5 ml-4" aria-label="主导航">
              <Link to="/" className={navLinkClass("/")}>
                首页
              </Link>
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className={navLinkClass(`/category/${cat.slug}`)}>
                  {cat.short}
                </Link>
              ))}
            </nav>

            <div className="hidden lg:flex items-center gap-3 ml-auto">
              <Link
                to="/about"
                className={`text-sm font-bold whitespace-nowrap cursor-pointer transition-colors ${
                  isActive("/about") ? "text-accent-700" : "text-foreground-700 hover:text-accent-700"
                }`}
              >
                关于我们
              </Link>
              <Link
                to="/about#contact"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-400 transition-colors"
              >
                <i className="ri-add-line w-4 h-4 flex items-center justify-center" />
                我要爆料
              </Link>
            </div>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              className="lg:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md border border-foreground-950 text-foreground-950 cursor-pointer"
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {menuOpen ? (
          <div className="lg:hidden border-t-2 border-foreground-950 bg-background-50">
            <nav className="px-4 py-4 grid grid-cols-2 gap-2" aria-label="移动端导航">
              <Link
                to="/"
                className="px-3 py-2.5 rounded-md bg-background-100 text-sm font-bold text-foreground-900 border border-background-200"
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-2.5 rounded-md bg-background-100 text-sm font-bold text-foreground-900 border border-background-200"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="px-3 py-2.5 rounded-md bg-background-100 text-sm font-bold text-foreground-900 border border-background-200"
              >
                关于我们
              </Link>
              <Link
                to="/about#contact"
                className="px-3 py-2.5 rounded-md bg-primary-500 text-sm font-bold text-foreground-950"
              >
                我要爆料
              </Link>
            </nav>
          </div>
        ) : null}
      </div>
    </header>
  );
}